import { useEffect, useState } from 'react';
import { fetchNotifications } from 'services/notifications';
import { useNotifications } from 'context/NotificationContext';

export default function useFetchNotifications() : { isLoading : boolean } {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { setNotifications } = useNotifications();

  useEffect(() => {
    const fetch = async () : Promise<void> => {
      try {
        setIsLoading(true);
        const data = await fetchNotifications();
        setNotifications(data);
      } catch {
        setNotifications([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetch();
  }, []);

  return { isLoading };
}